import { render, staticRenderFns } from "./RatioBarText.vue?vue&type=template&id=0299be93&scoped=true&lang=pug&"
import script from "./RatioBarText.vue?vue&type=script&lang=ts&"
export * from "./RatioBarText.vue?vue&type=script&lang=ts&"
import style0 from "./RatioBarText.vue?vue&type=style&index=0&id=0299be93&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0299be93",
  null
  
)

export default component.exports